<template>
    <div :class="index < 2 ? 'col-md-6' : 'col-md-4'">
        <a class="card" :class="post.acf.theme_color" :href="post.link">
            <div class="card__image">
                <img v-if="post.acf.page_header_image" :src="post.acf.page_header_image.sizes.medium" :alt="post.title.rendered" width="343" height="157" />
                <img v-else-if="post.acf.image" :src="post.acf.image.sizes.medium" :alt="post.title.rendered" width="343" height="157" />
            </div>
            <div class="card__content">
                <div class="label label--grey" v-html="post.acf.company"></div>
                <h3 class="card__title" v-html="post.title.rendered"></h3>
                <div class="cta-icon">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_2683_293" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="34" height="34">
                        <rect x="17" y="0.0292969" width="24" height="24" transform="rotate(45 17 0.0292969)" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_2683_293)">
                        <path d="M7.16659 17.5003L7.16659 16.4994H24.2786L19.1221 11.343L19.8292 10.6359L26.1932 16.9998L19.8292 23.3638L19.1221 22.6567L24.2786 17.5003L7.16659 17.5003Z" fill="#272A63"/>
                    </g>
                </svg>
            </div>
            </div>
        </a>
    </div>
</template>


<script>
    import moment from "moment";
    moment.locale('nl');

    export default{
        props: ['post', 'index'],
        methods: {
            getPostDate(date) {
                return moment(date).format("LL");
            },
        }
    }
</script>
